"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Orders = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const table_1 = require("../../components/web-view/table");
const button_1 = require("primereact/button");
const useIsMobile_1 = require("../../hooks/mobile/useIsMobile");
const react_i18next_1 = require("react-i18next");
const orders_module_scss_1 = __importDefault(require("./orders.module.scss"));
const getAll_1 = require("../../modules/orders/app/getAll");
const react_router_dom_1 = require("react-router-dom");
const useDebounce_1 = require("../../hooks/debounce/useDebounce");
const FiltersComponent_1 = require("../../components/filter/FiltersComponent");
const usePagination_1 = require("../../hooks/pagination/usePagination");
const dayjs_1 = __importDefault(require("dayjs"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
const timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
const datesHelpers_1 = require("../../common/utils/datesHelpers");
const FilterContext_1 = require("../../context/filters/FilterContext");
const ApiOrderRepo_1 = require("../../modules/orders/infra/ApiOrderRepo");
const OrderList_1 = require("./mobile/OrderList");
const getSummary_1 = require("../../modules/orders/app/getSummary");
const CheckOrdersModal_1 = require("./admin-settings/CheckOrdersModal");
const useOrders_1 = require("./context/useOrders");
const toastContext_1 = require("../../context/toast/toastContext");
const OrdersAddedModal_1 = require("./admin-settings/OrdersAddedModal");
const SummaryCard_1 = require("./headers/SummaryCard");
const HeaderBar_1 = require("./headers/HeaderBar");
const SortOptionModal_1 = require("./mobile/SortOptionModal");
const OrderSummaryDialog_1 = require("./mobile/OrderSummaryDialog");
const MobileListActions_1 = require("../../components/mobile/MobileListActions");
const FilterButton_1 = require("../../components/filter/filter-button/FilterButton");
const ActiveFilterChips_1 = require("../../components/chip/ActiveFilterChips");
const MobileFilterModal_1 = require("../../components/filter/filter-button/MobileFilterModal");
const MobilePillFilter_1 = require("../../components/filter/filter-button/MobilePillFilter");
const dateHelpers_1 = require("../../components/filter/dateHelpers");
const useClubMachineFilter_1 = require("../../hooks/filters/useClubMachineFilter");
const ExceedsPreauthIcon_1 = require("./components/ExceedsPreauthIcon");
const ExceedsPreauthBanner_1 = require("./components/ExceedsPreauthBanner");
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(timezone_1.default);
const repo = (0, ApiOrderRepo_1.createApiOrderRepo)();
const Orders = () => {
    const isMobile = (0, useIsMobile_1.useIsMobile)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { filters, setFilters } = (0, FilterContext_1.useFilters)();
    const [globalFilterValue, setGlobalFilterValue] = (0, react_1.useState)(filters.globalFilterValue || '');
    const [error, setError] = (0, react_1.useState)(null);
    const [checkOrdersFilters, setCheckOrdersFilters] = (0, react_1.useState)({
        startDate: filters.startDate
            ? new Date(filters.startDate).toISOString()
            : undefined,
        endDate: filters.endDate
            ? new Date(filters.endDate).toISOString()
            : undefined,
    });
    const localStorageFilters = JSON.parse(localStorage.getItem('filters') || '{}');
    const [dateFilter, setDateFilter] = (0, react_1.useState)(localStorageFilters.startDate && localStorageFilters.endDate
        ? [
            new Date(localStorageFilters.startDate),
            new Date(localStorageFilters.endDate),
        ]
        : datesHelpers_1.getDefaultDateRangeArray);
    const [isTyping, setIsTyping] = (0, react_1.useState)(false);
    const [orderSummary, setOrderSummary] = (0, react_1.useState)();
    const [isFirstLoad, setIsFirstLoad] = (0, react_1.useState)(true);
    const [openCheckOrdersModal, setOpenCheckOrdersModal] = (0, react_1.useState)(false);
    const [openResumeModal, setOpenResumeModal] = (0, react_1.useState)(false);
    const [ordersAdded, setOrdersAdded] = (0, react_1.useState)([]);
    const [dialogOpen, setDialogOpen] = (0, react_1.useState)(false);
    const debouncedFilterValue = (0, useDebounce_1.useDebounce)(globalFilterValue, 500);
    const [currentPage, setCurrentPage] = (0, react_1.useState)(() => {
        const storedPage = localStorage.getItem('currentPage');
        return storedPage ? parseInt(storedPage, 10) : 1;
    });
    const { checkOrders } = (0, useOrders_1.useOrders)();
    const { toastRef } = (0, toastContext_1.useToastContext)();
    const [loadingCheck, setLoadingCheck] = (0, react_1.useState)(false);
    const [sortField, setSortField] = (0, react_1.useState)('orderStartTs');
    const [sortOrder, setSortOrder] = (0, react_1.useState)(-1);
    const { tableFilters, displayFilters, filterFields, getFilterFields, optionsMap, handleTableFilterChange, handleRemoveFilter, handleClearAllFilters, activeFilterCount, displayActiveFilterCount, showMobileFilters, setShowMobileFilters, } = (0, useClubMachineFilter_1.useClubMachineFilter)({
        storageKey: 'orders',
        onFilterChange: () => {
            setCurrentPage(1);
            localStorage.setItem('currentPage', '1');
        },
    });
    const options = [
        { field: 'orderTime', label: t('date') },
        { field: 'invoiceNumber', label: t('invoice') },
        { field: 'machineName', label: t('machineNameSort') },
        { field: 'clubName', label: t('club') },
    ];
    const fetchOrders = (0, react_1.useCallback)(async (page = 1, pageSize = 10) => {
        try {
            if (isTyping)
                return;
            const fromDate = filters.startDate
                ? Math.floor(new Date(filters.startDate).getTime() / 1000).toString()
                : undefined;
            const toDate = filters.endDate
                ? Math.floor(new Date(filters.endDate).getTime() / 1000).toString()
                : undefined;
            const sort = [
                {
                    field: sortField,
                    direction: sortOrder === 1 ? 'asc' : 'desc',
                },
            ];
            return await (0, getAll_1.getAll)(repo, page, pageSize, debouncedFilterValue?.trim(), tableFilters.machines, tableFilters.clubs, fromDate, toDate, sort);
        }
        catch (err) {
            console.error('Fetch error:', err);
            setError('Error al cargar los datos');
            throw err;
        }
    }, [dateFilter, debouncedFilterValue, repo, sortField, sortOrder, tableFilters]);
    const fetchOrdersSummary = (0, react_1.useCallback)(async () => {
        try {
            if (isTyping)
                return;
            const fromDate = filters.startDate
                ? Math.floor(new Date(filters.startDate).getTime() / 1000).toString()
                : undefined;
            const toDate = filters.endDate
                ? Math.floor(new Date(filters.endDate).getTime() / 1000).toString()
                : undefined;
            return await (0, getSummary_1.getSummary)(repo, debouncedFilterValue.trim(), fromDate, toDate, tableFilters.machines, tableFilters.clubs);
        }
        catch (err) {
            console.error('Fetch error:', err);
            setError('Error al cargar los datos');
            throw err;
        }
    }, [debouncedFilterValue, dateFilter, tableFilters]);
    const { data, loading, fetchData, extraData } = (0, usePagination_1.usePagination)(parseInt(localStorage.getItem('currentPage') || '1', 10), 10, fetchOrders, (item) => item.id, undefined, (result) => result?.hasOrdersExceedingPreauth ?? false);
    const hasOrdersExceedingPreauth = extraData ?? false;
    const NAVBAR_MOBILE_HEIGHT = 56;
    const CONTENT_GAP = 20;
    const [mobileHeaderHeight, setMobileHeaderHeight] = (0, react_1.useState)(80);
    (0, react_1.useLayoutEffect)(() => {
        if (!isMobile)
            return;
        const findHeader = () => document.querySelector('.p-dataview-header');
        let el = findHeader();
        let attempts = 0;
        while (!el && attempts < 5) {
            attempts += 1;
            el = findHeader();
        }
        if (!el)
            return;
        const update = () => setMobileHeaderHeight(Math.max(el.offsetHeight, el.scrollHeight));
        update();
        const ro = new ResizeObserver(update);
        ro.observe(el);
        return () => ro.disconnect();
    }, [isMobile, hasOrdersExceedingPreauth, data.items.length]);
    const mobileTopOffset = NAVBAR_MOBILE_HEIGHT + mobileHeaderHeight + CONTENT_GAP;
    (0, react_1.useEffect)(() => {
        if (filters.startDate && filters.endDate) {
            setDateFilter([new Date(filters.startDate), new Date(filters.endDate)]);
        }
    }, [filters]);
    (0, react_1.useEffect)(() => {
        if (isFirstLoad) {
            setIsFirstLoad(false);
            return;
        }
        if (!filters.startDate || !filters.endDate)
            return;
        fetchData(currentPage, 10, false, filters.globalFilterValue, tableFilters.machines, tableFilters.clubs, filters.startDate, filters.endDate, undefined, undefined, [{ field: sortField, direction: sortOrder === 1 ? 'asc' : 'desc' }]);
    }, [
        sortField,
        sortOrder,
        filters.startDate,
        filters.endDate,
        filters.globalFilterValue,
        currentPage,
        isFirstLoad,
        ordersAdded,
        tableFilters,
    ]);
    (0, react_1.useEffect)(() => {
        if (isTyping)
            return;
        if (!dateFilter?.[0] || !dateFilter?.[1])
            return;
        const fetchSummaryData = async () => {
            try {
                const summaryData = await fetchOrdersSummary();
                setOrderSummary(summaryData);
            }
            catch (err) {
                console.error('Error fetching summary:', err);
            }
        };
        fetchSummaryData();
    }, [
        isTyping,
        debouncedFilterValue,
        dateFilter?.[0]?.getTime(),
        dateFilter?.[1]?.getTime(),
        tableFilters,
    ]);
    (0, react_1.useEffect)(() => {
        if (!isTyping && debouncedFilterValue !== undefined) {
            setFilters((prevFilters) => ({
                ...prevFilters,
                globalFilterValue: debouncedFilterValue,
            }));
        }
    }, [debouncedFilterValue, isTyping]);
    const onGlobalFilterChange = (e) => {
        const getFilters = JSON.parse(localStorage.getItem('filters') || '{}');
        const newFilters = {
            ...getFilters,
            globalFilterValue: e,
            clubId: filters.clubId,
        };
        setGlobalFilterValue(e);
        setCurrentPage(1);
        localStorage.setItem('currentPage', '1');
        localStorage.setItem('filters', JSON.stringify(newFilters));
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
        localStorage.setItem('currentPage', page.toString());
    };
    const handleSortChange = (field, order) => {
        setSortField(field);
        setSortOrder(order);
        setCurrentPage(1);
        localStorage.setItem('currentPage', '1');
    };
    const openDialog = () => setDialogOpen(true);
    const closeDialog = () => setDialogOpen(false);
    const columns = [
        {
            field: 'orderStartTs',
            header: 'date',
            renderFunc: (order) => {
                if (!order.orderStartTs)
                    return '';
                const localTime = dayjs_1.default
                    .unix(Number(order.orderStartTs))
                    .tz(dayjs_1.default.tz.guess())
                    .format('DD-MM-YYYY HH:mm:ss');
                return ((0, jsx_runtime_1.jsx)("span", { className: "font-semibold", children: localTime.toLocaleLowerCase() }));
            },
        },
        {
            field: 'operationId',
            header: 'operation',
            renderFunc: (order) => {
                if (!order.operationId)
                    return '';
                return (0, jsx_runtime_1.jsx)("span", { children: order.operationId });
            },
        },
        /* {
          field: 'invoiceNumber',
          header: 'invoice',
          renderFunc: (order) => {
            if (!order.invoiceNumber) return ''
            return <span className="font-semibold">{t(order.invoiceNumber)}</span>
          },
        },*/
        {
            field: 'machineName',
            header: 'machine',
            renderFunc: (order) => {
                if (!order.machineName)
                    return '';
                return (0, jsx_runtime_1.jsx)("span", { className: "font-semibold", children: order.machineName });
            },
        },
        {
            field: 'clubName',
            header: 'club',
            renderFunc: (order) => {
                if (!order.clubName)
                    return '';
                return (0, jsx_runtime_1.jsx)("span", { className: "font-semibold", children: order.clubName });
            },
        },
        {
            field: 'taxedAmount',
            header: 'amount',
            renderFunc: (order) => {
                const amount = Number(order?.taxedAmount);
                if (isNaN(amount))
                    return '';
                if (order.exceedsPreauthLimit) {
                    return ((0, jsx_runtime_1.jsxs)("span", { className: "inline-flex items-center justify-center gap-2 font-semibold text-amber-700", children: [(0, jsx_runtime_1.jsx)(ExceedsPreauthIcon_1.ExceedsPreauthIcon, {}), amount.toFixed(2), " EUR"] }));
                }
                return (0, jsx_runtime_1.jsxs)("span", { children: [amount.toFixed(2), " EUR"] });
            },
        },
    ];
    const handlerGotoDetail = (order) => {
        navigate(`/orders/${order.id}`);
    };
    const handlerDateFilter = (dates) => {
        const newFilters = {
            globalFilterValue,
            startDate: dates?.[0]?.toISOString() || null,
            endDate: dates?.[1]?.toISOString() || null,
            clubId: null,
        };
        setFilters(newFilters);
        setDateFilter(dates);
        localStorage.setItem('filters', JSON.stringify(newFilters));
    };
    const [showSortModal, setShowSortModal] = (0, react_1.useState)(false);
    const handleCheckOrdersFilters = (dates) => {
        setCheckOrdersFilters({
            startDate: dates?.[0]?.toISOString(),
            endDate: dates?.[1]?.toISOString(),
        });
    };
    const renderActionButtons = (order) => ((0, jsx_runtime_1.jsx)("div", { className: "flex justify-center gap-2", children: (0, jsx_runtime_1.jsx)(button_1.Button, { icon: "pi pi-eye", className: "p-button-rounded p-button-info p-button-outlined", onClick: () => handlerGotoDetail(order) }) }));
    const onConfirmCheckOrders = async () => {
        if (!checkOrdersFilters.startDate || !checkOrdersFilters.endDate) {
            console.error('Selected month or year is not defined');
            return Promise.reject();
        }
        const fromDate = Math.floor(new Date(checkOrdersFilters.startDate).getTime() / 1000).toString();
        const toDate = Math.floor(new Date(checkOrdersFilters.endDate).getTime() / 1000).toString();
        try {
            setLoadingCheck(true);
            const res = await checkOrders(fromDate, toDate);
            if (!res || res.length === 0) {
                toastRef.current?.show({
                    severity: 'info',
                    summary: t('Information'),
                    detail: t('rangeDateWithoutOrders'),
                    life: 3000,
                });
                return Promise.reject();
            }
            setOrdersAdded(res);
            setOpenCheckOrdersModal(false);
            toastRef.current?.show({
                severity: 'success',
                summary: t('Success'),
                detail: t('successGenerateOrders'),
                life: 3000,
            });
            setOpenResumeModal(true);
        }
        catch (error) {
            toastRef.current?.show({
                severity: 'error',
                summary: t('Error'),
                detail: t('errorGenerateOrders'),
                life: 3000,
            });
            return Promise.reject();
        }
        finally {
            setLoadingCheck(false);
        }
    };
    const onCancelRecalculate = () => {
        setOpenCheckOrdersModal(false);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isMobile && ((0, jsx_runtime_1.jsx)(MobileFilterModal_1.MobileFiltersModal, { visible: showMobileFilters, onHide: () => setShowMobileFilters(false), filters: getFilterFields, values: tableFilters, onFilterChange: handleTableFilterChange, activeCount: activeFilterCount })), (0, jsx_runtime_1.jsx)(OrdersAddedModal_1.OrdersAddedModal, { ordersAdded: ordersAdded, handleHide: () => setOpenResumeModal(false), visible: openResumeModal }), (0, jsx_runtime_1.jsx)(CheckOrdersModal_1.CheckOrdersModal, { visible: openCheckOrdersModal, onConfirm: onConfirmCheckOrders, onCancel: onCancelRecalculate, handlerDateFilter: handleCheckOrdersFilters, startTs: checkOrdersFilters.startDate, endTs: checkOrdersFilters.endDate, loading: loadingCheck }), (0, jsx_runtime_1.jsx)(SortOptionModal_1.SortOptionsModal, { visible: showSortModal, onHide: () => setShowSortModal(false), sortField: sortField, sortOrder: sortOrder, handleSortChange: handleSortChange, options: options }), isMobile ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(MobilePillFilter_1.MobilePillFilter, { filters: displayFilters, filterFields: filterFields, onRemoveFilter: handleRemoveFilter, onClearAll: handleClearAllFilters, topOffset: mobileTopOffset }), (0, jsx_runtime_1.jsx)(OrderList_1.OrderList, { orders: data.items, globalFilterValue: globalFilterValue, onGlobalFilterChange: onGlobalFilterChange, fetchData: fetchData, loading: loading, pagination: data.pagination, handlerDateFilter: handlerDateFilter, dateFilter: dateFilter, showExceedsPreauthBanner: hasOrdersExceedingPreauth, contentTopOffset: mobileTopOffset }), (0, jsx_runtime_1.jsx)(OrderSummaryDialog_1.OrderSummaryDialog, { visible: dialogOpen, onHide: closeDialog, orderSummary: orderSummary }), (0, jsx_runtime_1.jsx)(MobileListActions_1.MobileListActions, { actions: [
                            {
                                key: 'filter',
                                icon: 'pi pi-filter',
                                label: t('filter'),
                                onClick: () => setShowMobileFilters(true),
                                badge: displayActiveFilterCount,
                            },
                            {
                                key: 'sort',
                                icon: 'pi pi-sort-alt',
                                label: t('sort'),
                                onClick: () => setShowSortModal(true),
                            },
                            {
                                key: 'summary',
                                icon: 'pi pi-chart-bar',
                                label: t('summary'),
                                onClick: openDialog,
                            },
                        ] })] })) : ((0, jsx_runtime_1.jsxs)("div", { className: orders_module_scss_1.default.container, children: [(0, jsx_runtime_1.jsxs)("div", { className: orders_module_scss_1.default.tableHeader, children: [(0, jsx_runtime_1.jsx)(HeaderBar_1.HeaderBar, { title: t('ordersList'), titleSuffix: hasOrdersExceedingPreauth ? (0, jsx_runtime_1.jsx)(ExceedsPreauthBanner_1.ExceedsPreauthBanner, {}) : undefined, onSearch: (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-3", children: [(0, jsx_runtime_1.jsx)(FilterButton_1.FilterButton, { filters: getFilterFields, values: tableFilters, onFilterChange: handleTableFilterChange, buttonLabel: t('') }), (0, jsx_runtime_1.jsx)(FiltersComponent_1.FiltersComponent, { globalFilterValue: globalFilterValue, onGlobalFilterChange: onGlobalFilterChange, handlerDateFilter: handlerDateFilter, resetPageToFirst: () => setCurrentPage(1), inputFilterActive: true, quickFilters: [
                                                { id: 'today', label: t('today'), range: dateHelpers_1.getTodayRange },
                                                {
                                                    id: 'thisWeek',
                                                    label: t('thisWeek'),
                                                    range: dateHelpers_1.getThisWeekRange,
                                                },
                                                {
                                                    id: 'thisMonth',
                                                    label: t('thisMonth'),
                                                    range: dateHelpers_1.getThisMonthRange,
                                                },
                                            ] })] }) }), (0, jsx_runtime_1.jsx)(SummaryCard_1.SummaryCards, { summary: orderSummary, t: t }), (0, jsx_runtime_1.jsx)("div", { className: 'mt-2', children: (0, jsx_runtime_1.jsx)(ActiveFilterChips_1.ActiveFilterChips, { filters: displayFilters, optionsMap: optionsMap, onRemoveFilter: handleRemoveFilter }) })] }), (0, jsx_runtime_1.jsx)(table_1.AppTable, { columns: columns, actions: renderActionButtons, fetchData: fetchData, data: data, loading: loading, getKey: (item) => item.machineId, globalFilterFields: ['machineId'], currentPage: currentPage, handleCurrentPage: handlePageChange, enableSorting: true, sortableFields: [
                            'orderStartTs',
                            'invoiceNumber',
                            'machineName',
                            'clubName',
                            'taxedAmount',
                        ], sortField: sortField, sortOrder: sortOrder, defaultSort: 'orderStartTs', onSortChange: handleSortChange, rowClassName: (order) => order.exceedsPreauthLimit ? 'exceeds-preauth-row' : undefined })] }))] }));
};
exports.Orders = Orders;
